import React from 'react';

export type RowProps = React.HTMLAttributes<HTMLDivElement>;

const Row = ({ children, className, ...rest }: RowProps) => (
  <div className={'row ' + className} {...rest}>
    {children}
  </div>
);

export default Row;
